import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.template.html',
  styleUrls: ['footer.template.scss']
})
export class FooterComponent {

  data = new Date();
}
